export const MAX_MERCATOR_LATITUDE = 85.05112877980659;  //atan(sinh(PI)) *180 / PI
export const MIN_MERCATOR_LATITUDE = -85.05112877980659; //atan(sinh(PI)) *180 / PI
export const MAX_MERCATOR_LONGITUDE = 180.0;
export const MIN_MERCATOR_LONGITUDE = -180.0;

const isValidLat = (lat: number) => lat !== undefined &&
                                    lat !== null &&
                                    lat >= MIN_MERCATOR_LATITUDE &&
                                    lat <= MAX_MERCATOR_LATITUDE;

const isValidLng = (lng: number) => lng !== undefined &&
                                    lng !== null &&
                                    lng >= MIN_MERCATOR_LONGITUDE &&
                                    lng <= MAX_MERCATOR_LONGITUDE;

export const isValidLatForMatch = (lat: number) => isValidLat(lat) && 
                                                   lat !== 0;

export const isValidLngForMatch = (lng: number) => isValidLng(lng) && 
                                                   lng !== 0;

export const isValidLatForMobilytics = (lat: number) => isValidLat(lat) && 
                                                        lat !== 0;

export const isValidLngForMobilytics = (lng: number) => isValidLng(lng) && 
                                                        lng !== 0;
                                                        

export const isValidLatLngForMatch = (lat: number, lng: number) => isValidLatForMatch(lat) &&
                                                                   isValidLngForMatch(lng);

export const isValidLatLngForMobilytics = (lat: number, lng: number) => isValidLatForMobilytics(lat) && 
                                                                        isValidLngForMobilytics(lng);